import { combineReducers } from "redux";
import geral from "./geral/cadenciaEmails";
import listaDinamica from "../Listas/ListaDinamica/reducer";

export default combineReducers({
  geral,
  listaDinamica,
});
